import operatorApiService from "../../api/raily/operator/operator-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import HttpError from "../../utils/http/http.error";
import OperatorAddParams from "./add/operator-add-params";
import OperatorAddRequest from "../../api/raily/operator/add/operator-add-request";
import operatorAddParamsFactory from "./add/operator-add-params.factory";
import OperatorAddError from "./add/operator-add-error";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";

const add = async (
  params: OperatorAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: OperatorAddRequest = operatorAddParamsFactory.create(params);

  try {
    const response = await operatorApiService().add(request, abortSignal);

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | OperatorAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const operatorService = {
  add,
};

export default operatorService;
